import { SpendingPoliciesPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSpendingPoliciesPage = (companyId: string) => {
  const { data, loading, error } = useQuery(SpendingPoliciesPageDocument, {
    variables: {
      companyId: companyId.toString(),
      featureCompanyId: companyId,
    },
  })

  return {
    data,
    loading,
    error,
  }
}
